"use client";

import { useParams } from "@tanstack/react-router";

type ShopPlaceholderPageProps = {
  title: string;
};

export function ShopPlaceholderPage({ title }: ShopPlaceholderPageProps) {
  const params = useParams({ strict: false });
  const shopId = params?.shopId as string | undefined;

  return (
    <div className="container py-8">
      <h1 className="mb-2 font-semibold text-xl">{title}</h1>
      <p className="text-muted-foreground text-sm">ລາຍການ: {shopId ?? "—"}</p>
      <p className="mt-4 text-muted-foreground">ໜ້ານີ້ເປັນ placeholder.</p>
    </div>
  );
}
